import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ErpListToolbar({
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Cari data...",
  filters,
  actions,
  resultCount,
  onReset,
}) {
  const hasSearch = Boolean(searchValue);
  return (
    <div className="mb-4 space-y-3">
      <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
        {onSearchChange && (
          <div className="relative min-w-0 flex-1 lg:max-w-md">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            <Input
              value={searchValue}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder}
              className="pl-9 pr-9"
            />
            {hasSearch && (
              <button
                type="button"
                aria-label="Hapus pencarian"
                onClick={() => onSearchChange("")}
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-400 hover:bg-slate-100"
              >
                <X className="h-3.5 w-3.5" />
              </button>
            )}
          </div>
        )}
        {filters && <div className="flex flex-wrap items-center gap-2">{filters}</div>}
        <div className="flex flex-wrap items-center gap-2 lg:ml-auto">
          {onReset && (
            <Button type="button" variant="ghost" size="sm" onClick={onReset}>
              Reset filter
            </Button>
          )}
          {actions}
        </div>
      </div>
      {resultCount !== undefined && resultCount !== null && (
        <p className="text-xs text-slate-500" aria-live="polite">
          {Number(resultCount).toLocaleString("id-ID")} data
        </p>
      )}
    </div>
  );
}
